import MainAreaWrapper from "../layout/MainAreaWrapper";
import { Link } from "react-router-dom";

const TestData = () => {

  return (
    <MainAreaWrapper>
      <main className="mt-28 lg:mt-10 bg-gradient-to-b from-[#FAFCFEBF]/70 via-[#FAFCFEBF]/50 to-transparent rounded-t-3xl">
        {/* <Breadcrumb /> */}
        <div className="mx-auto p-2 md:p-6 2xl:p-10">
          {/* <!-- ===== Content Area Start ===== --> */}
          <div className="mb-6 px-2 py-3">
            {/* <UserProfileMenuBar /> */}


            <div className="flex items-center gap-3">
              <span className="text-[#1D3E7D] text-4xl font-bold">
                Test Data
              </span>
              <span className="flex items-center gap-1 px-2 py-0.5 bg-yellow-100 text-yellow-800 text-xs font-medium rounded-full">
                <svg
                  className="w-3.5 h-3.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.287 3.956a1 1 0 00.95.69h4.162c.969 0 1.371 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.957c.3.92-.755 1.688-1.54 1.118l-3.371-2.449a1 1 0 00-1.175 0l-3.37 2.45c-.786.57-1.84-.198-1.54-1.119l1.287-3.957a1 1 0 00-.364-1.118L2.073 9.383c-.783-.57-.38-1.81.588-1.81h4.162a1 1 0 00.95-.69l1.287-3.956z" />
                </svg>
                Beta
              </span>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-5 sm:justify-start">
            {/* <!-- <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7.5"> --> */}

            <div className="flex flex-wrap justify-center md:justify-start gap-5">


              <Link
                id="Root Cause Analysis"
                to="/rootCauseAnalysis"
                className="bg-white rounded-3xl w-24 sm:w-40 md:w-52 h-32 sm:h-40 p-3 py-5 shadow-[0_10px_10px_rgb(0,0,0,0.2)] flex flex-col space-y-3 justify-center items-center text-center relative"
              >
                <h2 className="font-bold sm:text-2xl text-[#4a4a68] leading-5">
                  Root Cause Analysis
                </h2>
                <img
                  src="./icons/RootCause.svg"
                  alt="Root Cause Analysis"
                  className="w-10 h-10 sm:w-16 sm:h-16"
                />
              </Link>


            </div>
          </div>
        </div>
      </main>
    </MainAreaWrapper >
  );
};

export default TestData;
